import { useState } from "react";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { Logo } from "@/components/landing/Logo";
import { formatApiErrorDetail } from "@/lib/adminApi";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const inputCls =
  "w-full bg-white border border-[#122A1D]/15 focus:border-[#C8A24A] focus:outline-none text-[#122A1D] px-5 py-3.5 font-light transition-colors duration-300";

export const AdminLogin = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("admin_token", data.token);
      onLogin(data.email);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#F7F6F1] flex items-center justify-center px-6">
      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="w-full max-w-md bg-white border border-[#122A1D]/10 shadow-[0_12px_40px_rgba(18,42,29,0.08)] p-10 space-y-5"
      >
        <div className="flex justify-center mb-2">
          <Logo />
        </div>
        <p className="text-center text-xs uppercase tracking-[0.3em] text-[#8C6A1F]">Admin CMS</p>
        <input
          data-testid="admin-login-email"
          type="email"
          required
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className={inputCls}
        />
        <input
          data-testid="admin-login-password"
          type="password"
          required
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className={inputCls}
        />
        {error && (
          <p data-testid="admin-login-error" className="text-sm text-red-700 bg-red-50 border border-red-200 px-4 py-2">
            {error}
          </p>
        )}
        <button
          type="submit"
          disabled={loading}
          data-testid="admin-login-submit"
          className="w-full bg-[#C8A24A] text-[#0B1F16] hover:bg-[#B8923D] disabled:opacity-60 font-semibold transition-colors duration-300 px-8 py-3.5 uppercase tracking-wider text-sm flex items-center justify-center gap-2"
        >
          {loading && <Loader2 size={16} className="animate-spin" />}
          Sign in
        </button>
      </form>
    </div>
  );
};
